import { IHomepageSessionLayout } from '@/interfaces/components/layout.interface';

const SectionLayout: React.FC<IHomepageSessionLayout> = ({
  children,
  isInsideBox = false,
}) => {
  return (
    <main>
      <div className={`px-6 md:px-10 lg:px-24 ${!isInsideBox && '2xl:px-56'}`}>
        {children}
      </div>
    </main>
  );
};

export default SectionLayout;
